/** Partner logos via jsDelivr (simple-icons) — reliable slugs for enterprise stack */
export const PARTNER_LOGOS = [
  { name: "Oracle", slug: "oracle" },
  { name: "Microsoft SQL Server", slug: "microsoftsqlserver" },
  { name: "PostgreSQL", slug: "postgresql" },
  { name: "Red Hat", slug: "redhat" },
  { name: "AWS", slug: "amazonaws" },
  { name: "Azure", slug: "microsoftazure" },
  { name: "Google Cloud", slug: "googlecloud" },
  { name: "Nginx", slug: "nginx" },
  { name: "Apache Tomcat", slug: "apachetomcat" },
  { name: "Linux", slug: "linux" },
  { name: "Windows", slug: "windows" },
  { name: "Docker", slug: "docker" },
];

const SIMPLE_ICONS_VERSION = "11.14.0";

export const partnerLogoUrl = (slug) =>
  `https://cdn.jsdelivr.net/npm/simple-icons@${SIMPLE_ICONS_VERSION}/icons/${slug}.svg`;
